import type { SegmentedControlValue } from "@similarweb/ui-components";
import { SegmentedControl } from "@similarweb/ui-components";

type HighLevelMetricsComparisonChartSwitcherProps = {
    values: SegmentedControlValue[];
    selectedIndex?: number;
    onChange: (selectedIndex: number) => void;
};

export const HighLevelMetricsComparisonChartSwitcher = ({
    values,
    selectedIndex,
    onChange,
}: HighLevelMetricsComparisonChartSwitcherProps) => {
    return (
        <SegmentedControl
            values={values}
            onChange={onChange}
            selectedIndex={selectedIndex}
        />
    );
};
